import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';

const EVENTOS = [
  {
    id: 'agro-capital',
    titulo: 'INOVA AGRO - AGROCAPITAL 2026',
    tipo: 'FEIRA',
    data: '01 JUN',
    dataCompleta: '01 à 05 de junho de 2026',
    horario: '09:00 - 22:00',
    local: 'AGROCAPITAL, Goiânia',
    modalidade: 'Presencial',
    imagem: '/imagem/eventos/agrocapital.png',
    imagemPatrocinio: '/imagem/eventos/inova-patrocinio.png',

    certificados: [
      { nome: 'Certificado de Palestrantes', link: 'https://drive.google.com/drive/folders/1Jo4p50Nkc9ZtSkyXaUALcy9CRgWIYh80?usp=sharing' },
      { nome: 'Certificado Prêmio Destaque Alysson Paolinelli', link: 'https://drive.google.com/drive/folders/12Pf4MFGqIEtk8lYKkPox6lMThrz8EssH?usp=sharing' },
      { nome: 'Certificado de Participação no Inova Agro', link: 'https://drive.google.com/drive/folders/1ychvEiEUfbBkp_tn8_viVGLoTb4PxWVi?usp=sharing' },
      { nome: 'Certificado de Apresentação de Trabalho', link: 'https://drive.google.com/drive/folders/1fA5j5WyS2R6SVvn9CFFGye_22xstI8Id?usp=sharing' },
    ],

    descricao: [
      'O INOVA AGRO - AGROCAPITAL 2026 é um evento desenhado para quem quer fazer negócio de verdade, conectar tecnologia ao campo e colocar sua marca frente a frente com quem decide.',
    ],

    programacao: [
      '/documentos/programação-agro-capital.pdf',
    ],

    trabalho: [
      '/documentos/Trabalhos aceitos para Publicação.pdf',
    ],

    inscricaoTexto: 'Clique no botão abaixo para garantir sua participação no INOVA AGRO - AGROCAPITAL 2026.',
    linkInscricao: 'https://forms.gle/FPRnL98uthYqjrcq6',

    observacoes: [
      'Acesse:',
      'https://www.instagram.com/agrocapitaloficial/',
      'https://agrocapitaloficial.com.br/',
    ],

    documentos: [
      { nome: 'Orientação aos Autores sobre o Uso de Inteligência Artificial (IA)', arquivo: '/documentos/Orientação aos Autores sobre o Uso de Inteligência Artificial (IA).pdf' },
      { nome: 'Instruções Gerais para Formas de Apresentação em Banner', arquivo: '/documentos/Instruções Gerais para Formas de Apresentação em Banner.pdf' },
      { nome: 'Instruções Gerais para Formas de Apresentação Remota (On-Line)', arquivo: '/documentos/Instruções Gerais para Formas de Apresentação Remota (On-Line).pdf' },
      { nome: 'Modelo Resumo AgroCapital', arquivo: '/documentos/Modelo_Resumo_AgroCapital.docx' },
      { nome: 'Modelo Apresentação Formato Remoto (On-Line)', arquivo: '/documentos/Modelo apresentação formato remoto (On line).pptx' },
      { nome: 'Template Inova Agro', arquivo: '/documentos/TEMPLATE INOVA AGRO.pptx' },
    ],

    galeria: [
      '/imagem/eventos/inova-agro-resumos.jpeg',
      '/imagem/eventos/Prancheta 1.png',
      '/imagem/eventos/Prancheta 2.png',
      '/imagem/eventos/Prancheta 3.png',
      '/imagem/eventos/Prancheta 4.png',
      '/imagem/eventos/Prancheta 5.png',
      '/imagem/eventos/Prancheta 6.png',
      '/imagem/eventos/inova-agro.jpeg',
    ],

    palestrantes: [
      '/imagem/eventos/P1.jpeg',
      '/imagem/eventos/P2.jpeg',
      '/imagem/eventos/P3.jpeg',
      '/imagem/eventos/P4.jpeg',
      '/imagem/eventos/P5.jpeg',
      '/imagem/eventos/P6.jpeg',
      '/imagem/eventos/P7.jpeg',
      '/imagem/eventos/P8.jpeg',
      '/imagem/eventos/P9.jpeg',
      '/imagem/eventos/P10.jpeg',
      '/imagem/eventos/P11.jpeg',
      '/imagem/eventos/P12.jpeg',
      '/imagem/eventos/P13.jpeg',
      '/imagem/eventos/P14.jpeg',
      '/imagem/eventos/P15.jpeg',
      '/imagem/eventos/P16.jpeg',
      '/imagem/eventos/P17.jpeg',
      '/imagem/eventos/P18.jpeg',
      '/imagem/eventos/P19.jpeg',
      '/imagem/eventos/P20.jpeg',
      '/imagem/eventos/P21.jpeg',
      '/imagem/eventos/P22.jpeg',
      '/imagem/eventos/P23.jpeg',
      '/imagem/eventos/P24.jpeg',
      '/imagem/eventos/P25.jpeg',
      '/imagem/eventos/P26.jpeg',
    ],

    trabalhosCientificos: [
      '/imagem/eventos/b01.jpeg',
      '/imagem/eventos/b02.jpeg',
      '/imagem/eventos/b03.jpeg',
      '/imagem/eventos/b04.jpeg',
      '/imagem/eventos/b05.jpeg',
      '/imagem/eventos/b06.jpeg',
      '/imagem/eventos/b07.jpeg',
      '/imagem/eventos/b08.jpeg',
      '/imagem/eventos/b09.jpeg',
      '/imagem/eventos/b10.jpeg',
      '/imagem/eventos/b11.jpeg',
      '/imagem/eventos/b12.jpeg',
      '/imagem/eventos/b13.jpeg',
      '/imagem/eventos/b14.jpeg',
      '/imagem/eventos/b15.jpeg',
      '/imagem/eventos/b16.jpeg',
      '/imagem/eventos/b17.jpeg',
      '/imagem/eventos/b18.jpeg',
      '/imagem/eventos/b19.jpeg',
      '/imagem/eventos/b20.jpeg',
      '/imagem/eventos/b21.jpeg',
      '/imagem/eventos/b22.jpeg',
      '/imagem/eventos/b23.jpeg',
      '/imagem/eventos/b24.jpeg',
      '/imagem/eventos/b25.jpeg',
      '/imagem/eventos/b26.jpeg',
      '/imagem/eventos/b27.jpeg',
      '/imagem/eventos/b28.jpeg',
      '/imagem/eventos/b29.jpeg',
      '/imagem/eventos/b30.jpeg',
      '/imagem/eventos/b31.jpeg',
    ],
  },
  {
    id: 'cong-aviacao',
    titulo: 'Congresso da Aviação Agrícola do Brasil',
    tipo: 'EVENTO',
    data: '18-20 AGO',
    dataCompleta: '18 à 20 de agosto de 2026',
    horario: '10:00 - 18:00',
    local: 'Condomínio Aeronáutico Liberty (S.N.L.L), Goiânia',
    modalidade: 'Presencial',
    imagem: '/imagem/eventos/aviacao-agricola.png',

    descricao: [
      'Principal evento mundial do setor da aviação agrícola.',
    ],

    programacao: [
      'Acesse o site do evento para mais informações',
    ],

    inscricaoTexto: 'Garanta seu espaço no principal evento mundial da aviação agrícola.',
    linkInscricao: 'https://congressoavag.org.br/',
  },

  {
    id: 'agromkt-summit-2026',
    titulo: 'AgroMKT Summit 2026',
    tipo: 'CONGRESSO',
    data: '04-05 SET',
    dataCompleta: '04 e 05 de setembro de 2026',
    local: 'Teatro SESI, Goiânia – GO',
    modalidade: 'Presencial',
    imagem: '/imagem/eventos/agromkt.jpeg',

    descricao: [
      'Conexões fortes constroem um agro mais preparado para o futuro.',
      'O AgroMKT Summit 2026 amplia sua rede de parceiros institucionais com a AEAGO e o Fórum Brasil Central, unindo entidades que acreditam no desenvolvimento, na inovação, no conhecimento e na geração de novas oportunidades para o agronegócio.',
      'Nos dias 04 e 05 de setembro, o Teatro SESI, em Goiânia, recebe uma edição ainda maior do AgroMKT Summit, reunindo produtores rurais, empresários, líderes, gestores e profissionais que estão ajudando a transformar o agro dentro e fora da porteira.',
      'Serão mais de 50 especialistas, 15 palestras, 8 painéis e 5 workshops — dois dias de conteúdo, visão de mercado, networking e conexões estratégicas para quem quer crescer, inovar, vender mais e construir negócios mais fortes no agronegócio.',
      'A parceria com a AEAGO e o Fórum Brasil Central reforça um propósito que é maior do que o próprio evento: conectar pessoas e instituições que estão construindo o futuro do agro brasileiro.',
    ],

    inscricaoTexto: 'Garanta seu passaporte para os dois dias de conteúdo, networking e negócios do AgroMKT Summit 2026, pelo site oficial.',
    linkInscricao: 'https://www.sympla.com.br/evento/agromkt-summit-2026-congresso-internacional-de-negocios-inovacao-e-marketing-para-o-agro/3173774?utm_source=ig&utm_medium=social&utm_content=link_in_bio&fbclid=PAcGRvZgJleHRuA2FlbQIxMQBzcnRjBmFwcF9pZA85MzY2MTk3NDMzOTI0NTkAAad3uU37fQ63pj6gKBP4_YEgZAJJsUlOUt2dOzsJqZiM7kZUfJW4qJnSxcrEzA_aem_J7tQEhGQsxcaKa3v4_Fr-g&utm_id=97760_v0_s00_e0_tv3&referrer=l.instagram.com&referrer=l.instagram.com',

    observacoes: [
      'Acompanhe:',
      'https://www.instagram.com/agromktsummit/',
      'https://www.instagram.com/p/Dc_yx9PJteO/',
    ],
  },

];

function Carrossel({ imagens, titulo }) {
  const [atual, setAtual] = useState(0);

  const anterior = () => setAtual((i) => (i === 0 ? imagens.length - 1 : i - 1));
  const proximo  = () => setAtual((i) => (i === imagens.length - 1 ? 0 : i + 1));

  return (
    <section className="mb-10">
      <h2 className="text-2xl font-bold text-navy mb-4">{titulo}</h2>
      <div className="relative w-full overflow-hidden rounded-2xl shadow-md bg-gray-100">
        <img
          src={process.env.PUBLIC_URL + imagens[atual]}
          alt={`Imagem ${atual + 1}`}
          className="w-full max-h-[480px] object-contain mx-auto"
        />

        {/* Botão anterior */}
        <button
          onClick={anterior}
          className="absolute left-3 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-navy rounded-full w-10 h-10 flex items-center justify-center shadow transition"
          aria-label="Imagem anterior"
        >
          ‹
        </button>

        {/* Botão próximo */}
        <button
          onClick={proximo}
          className="absolute right-3 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-navy rounded-full w-10 h-10 flex items-center justify-center shadow transition"
          aria-label="Próxima imagem"
        >
          ›
        </button>

        {/* Contador */}
        <span className="absolute bottom-3 right-4 text-xs text-white bg-black/40 px-2 py-1 rounded-full">
          {atual + 1} / {imagens.length}
        </span>
      </div>

      {/* Pontos */}
      <div className="flex justify-center gap-2 mt-4">
        {imagens.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setAtual(idx)}
            className={`w-2.5 h-2.5 rounded-full transition ${idx === atual ? 'bg-navy' : 'bg-gray-300'}`}
            aria-label={`Ir para imagem ${idx + 1}`}
          />
        ))}
      </div>
    </section>
  );
}

export default function EventoDetalhe() {
  const { id } = useParams();
  const evento = EVENTOS.find((e) => e.id === id);

  if (!evento) {
    return (
      <div className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-2xl font-bold text-navy">Evento não encontrado</h1>
        <Link to="/#eventos" className="mt-4 inline-block text-navy underline">
          Voltar para eventos
        </Link>
      </div>
    );
  }

  const temImagem = Boolean(evento.imagem);
  const temProgramacao = Array.isArray(evento.programacao) && evento.programacao.length > 0;
  const temObservacoes = Array.isArray(evento.observacoes) && evento.observacoes.length > 0;
  const temInscricao = Boolean(evento.inscricaoTexto || evento.linkInscricao);
  const temTrabalhos = Array.isArray(evento.trabalho) && evento.trabalho.length > 0;

  return (
    <article className="max-w-4xl mx-auto px-6 pt-28 pb-12 text-center">
      <div className="max-w-3xl mx-auto">
        {/* Tipo */}
        {evento.tipo && (
          <span className="inline-block bg-blue-100 text-navy text-sm font-medium px-4 py-1 rounded-full mb-4">
            {evento.tipo}
          </span>
        )}

        {/* Título */}
        <h1 className="text-3xl md:text-5xl font-bold text-navy leading-tight mb-4">
          {evento.titulo}
        </h1>

        {/* Meta informações */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-gray-600 mb-8">
          {evento.dataCompleta && (
            <p>
              <span className="font-semibold text-navy">Data:</span> {evento.dataCompleta}
            </p>
          )}

          {evento.horario && (
            <p>
              <span className="font-semibold text-navy">Horário:</span> {evento.horario}
            </p>
          )}

          {evento.local && (
            <p>
              <span className="font-semibold text-navy">Local:</span> {evento.local}
            </p>
          )}

          {evento.modalidade && (
            <p>
              <span className="font-semibold text-navy">Modalidade:</span> {evento.modalidade}
            </p>
          )}
        </div>

        {/* Imagem principal */}
        {temImagem && (
          <div className="mb-10">
            <img
              src={process.env.PUBLIC_URL + evento.imagem}
              alt={evento.titulo}
              className="w-full object-contain rounded-2xl shadow-md"
            />
          </div>
        )}

        {/* Certificados */}
        {evento.certificados?.length > 0 && (
          <section className="mb-10 bg-white rounded-2xl shadow-sm border border-gray-200 p-6 text-center">
            <h2 className="text-2xl font-bold text-navy mb-2">Certificados</h2>
            <p className="text-gray-500 mb-6 text-sm">Acesse sua pasta no Google Drive e localize seu certificado pelo nome.</p>
            <ul className="space-y-4">
              {evento.certificados.map((cert, idx) => (
                <li key={idx}>
                  <a
                    href={cert.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-3 bg-navy text-white px-6 py-3 rounded-full font-medium hover:opacity-90 transition"
                  >
                    <span className="text-lg">🎓</span>
                    {cert.nome}
                  </a>
                </li>
              ))}
            </ul>
          </section>
        )}

        {/* Descrição */}
        <section className="mb-10">
          <h2 className="text-2xl font-bold text-navy mb-4">Sobre o evento</h2>
          <div className="space-y-5 text-gray-700 leading-relaxed text-[17px]">
            {evento.descricao?.map((paragrafo, idx) => (
              <p key={idx}>{paragrafo}</p>
            ))}
          </div>
        </section>

        {/* Programação */}
        {temProgramacao && (
          <section className="mb-10 bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
            <h2 className="text-2xl font-bold text-navy mb-4">Programação</h2>
            <ul className="space-y-3 text-gray-700 text-center">
              {evento.programacao.map((item, idx) => {
                const isArquivo = item.startsWith('/');
                return (
                  <li key={idx} className="border-b border-gray-100 pb-3 last:border-b-0 last:pb-0">
                    {isArquivo ? (
                      <a
                        href={process.env.PUBLIC_URL + encodeURI(item)}
                        download
                        className="flex items-center justify-center gap-3 text-navy font-medium hover:opacity-75 transition"
                      >
                        <span className="text-xl">📄</span>
                        Baixar programação
                      </a>
                    ) : (
                      item
                    )}
                  </li>
                );
              })}
            </ul>
          </section>
        )}

        {/* Inscrição */}
        {temInscricao && (
          <section className="mb-10 bg-blue-50 rounded-2xl border border-blue-100 p-6">
            <h2 className="text-2xl font-bold text-navy mb-4">Inscrição</h2>

            {evento.inscricaoTexto && (
              <p className="text-gray-700 leading-relaxed mb-4">{evento.inscricaoTexto}</p>
            )}

            {evento.linkInscricao && (
              <a
                href={evento.linkInscricao}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-navy text-white px-6 py-3 rounded-full font-medium hover:opacity-90 transition"
              >
                Fazer inscrição
              </a>
            )}
          </section>
        )}

        {/* Documentos Importantes */}
        {evento.documentos?.length > 0 && (
          <section className="mb-10 bg-white rounded-2xl shadow-sm border border-gray-200 p-6 text-center">
            <h2 className="text-2xl font-bold text-navy mb-4">Documentos Importantes</h2>
            <ul className="space-y-3">
              {evento.documentos.map((doc, idx) => (
                <li key={idx}>
                  <a
                    href={process.env.PUBLIC_URL + encodeURI(doc.arquivo)}
                    download
                    className="flex items-center justify-center gap-3 text-navy font-medium hover:opacity-75 transition"
                  >
                    <span className="text-xl">📄</span>
                    {doc.nome}
                  </a>
                </li>
              ))}
            </ul>
          </section>
        )}

        {/* Trabalhos */}
        {temTrabalhos && (
          <section className="mb-10 bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
            <h2 className="text-2xl font-bold text-navy mb-4">Trabalhos Aceitos</h2>
            <ul className="space-y-3">
              {evento.trabalho.map((trab, idx) => (
                <li key={idx}>
                  <a
                    href={process.env.PUBLIC_URL + encodeURI(trab)}
                    download
                    className="flex items-center justify-center gap-3 text-navy font-medium hover:opacity-75 transition"
                  >
                    <span className="text-xl">📄</span>
                    Trabalhos aceitos para publicação
                  </a>
                </li>
              ))}
            </ul>
          </section>
        )}

        {/* Patrocinadores */}
        {evento.imagemPatrocinio && (
          <div className="mb-10">
            <img
              src={process.env.PUBLIC_URL + evento.imagemPatrocinio}
              alt="Patrocinadores"
              className="w-full object-contain rounded-2xl"
            />
          </div>
        )}

        {/* Galeria */}
        {evento.galeria?.length > 0 && <Carrossel imagens={evento.galeria} titulo="Galeria"/>}

        {/* Palestrantes */}
        {evento.palestrantes?.length > 0 && <Carrossel imagens={evento.palestrantes} titulo="Palestrantes"/>}

        {/* Trabalhos Científicos */}
        {evento.trabalhosCientificos?.length > 0 && <Carrossel imagens={evento.trabalhosCientificos} titulo="Trabalhos Científicos"/>}

        {/* Observações */}
        {temObservacoes && (
          <section className="mb-10">
            <h2 className="text-2xl font-bold text-navy mb-4">Informações importantes</h2>
            <ul className="space-y-2 text-gray-700 leading-relaxed">
              {evento.observacoes.map((obs, idx) => {
                const isUrl = /^https?:\/\//.test(obs);
                return (
                  <li key={idx}>
                    {isUrl ? (
                      <a
                        href={obs}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-navy underline hover:opacity-75 break-all"
                      >
                        {obs}
                      </a>
                    ) : (
                      obs
                    )}
                  </li>
                );
              })}
            </ul>
          </section>
        )}

        {/* Voltar */}
        <div className="mt-12">
          <Link
            to="/#eventos"
            className="inline-flex items-center text-navy hover:underline font-medium"
          >
            ← Voltar para eventos
          </Link>
        </div>
      </div>
    </article>
  );
}
